import {useValueLists} from '@common/http/value-lists';
import {FormSelect, Option, OptionGroup} from '@ui/forms/select/select';
import {Trans} from '@ui/i18n/trans';
import React from 'react';
import clsx from 'clsx';
import {RequestTitle} from '@app/titles/models/Request';

export function CategorySelect({
  category,
  className,
}: {
  category?: RequestTitle['category'];
  className?: string;
}) {
  const {data} = useValueLists(['titleFilterCategories']);

  return (
    <FormSelect
      name="category"
      defaultValue={category}
      selectionMode="single"
      label={<Trans message="Category" />}
      showSearchField
      searchPlaceholder="Search categories"
      className={clsx('flex-1', className)}
    >
      {data?.titleFilterCategories.map(group => (
        <OptionGroup key={group.name} label={group.name}>
          {group.options.map(option => (
            <Option key={option.value} value={option.value}>
              <Trans message={option.name} />
            </Option>
          ))}
        </OptionGroup>
      ))}
    </FormSelect>
  );
}
